const getSupplierPhone2 = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business['Company Contact'] && business['Company Contact']['Phone Number']
    ? business['Company Contact']['Phone Number'].replace('+1 ', '').replace(/[\s()-]/g, '').slice(3, 6) : null;
};

export default getSupplierPhone2;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierPhone2.js